import {
  debounce,
  eventBus,
  INTERNAL_EVENTS,
  startSession,
  useBaseStore,
  useLayout,
} from '@cometchat/calls-sdk-core';
import clsx from 'clsx';
import React, { useEffect, useLayoutEffect } from 'react';
import '../web-only';
import './call-screen.css';
import CallStage from './CallStage.web';
import { ConfirmationDialog } from './confirmation-dialog/ConfirmationDialog';
import ControlPane from './control-pane/ControlPane.web';
import Header from './header/Header.web';
import IdealTimeoutModal from './ideal-timeout/IdealTimeoutModal';
import InfoView from './info-view/InfoView';
import ParticipantList from './participants/ParticipantList.web';
import ConnectionLoader from './shared/ConnectionLoader.web';
import NotificationContainer from './shared/NotificationContainer.web';

function CallScreen() {
  const participantListVisible = useBaseStore(
    state => state.participantListVisible,
  );
  const layout = useLayout();

  const [isConnectionClosed, setIsConnectionClosed] = React.useState(false);

  useLayoutEffect(() => {
    eventBus.publish({
      type: INTERNAL_EVENTS.lifecycle.componentDidMount,
    });
    return () => {
      eventBus.publish(
        {
          type: INTERNAL_EVENTS.lifecycle.componentWillUnmount,
        },
        true,
      );
    };
  }, []);

  useEffect(() => {
    startSession();
  }, []);

  useEffect(() => {
    return eventBus.subscribe('onConnectionClosed', () => {
      setTimeout(() => {
        setIsConnectionClosed(true);
      }, 0);
    });
  }, []);

  if (isConnectionClosed) {
    // TODO: Localize this string
    return <InfoView text="The session has ended." />;
  }

  return (
    <div className="cometchat-calls-call-screen-container">
      <div
        className={clsx('cometchat-calls-call-screen-content-wrapper', {
          'cometchat-calls-call-screen--participant-list-open':
            participantListVisible,
          'cometchat-calls-call-screen--sidebar-mode': layout === 'SIDEBAR',
          'cometchat-calls-call-screen--spotlight-mode': layout === 'SPOTLIGHT',
        })}>
        <div
          className="cometchat-calls-call-screen-main-content"
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            boxSizing: 'border-box',
          }}
          onClick={useBaseStore.getState().restartIdealTimeoutTimer}>
          <Header />
          <div
            className="cometchat-calls-call-stage-wrapper"
            ref={el => {
              if (el) {
                const resizeObserver = new ResizeObserver(
                  debounce(entries => {
                    for (const entry of entries) {
                      const { width, height } = entry.contentRect;
                      useBaseStore.setState({
                        mainAreaDimension: {
                          width,
                          height,
                        },
                      });
                    }
                  }, 1000),
                );
                resizeObserver.observe(el);
                return () => resizeObserver.disconnect();
              }
            }}>
            <CallStage />
          </div>
          <ControlPane />
          <ConnectionLoader />
        </div>
        <div className="cometchat-calls-participant-list-wrapper">
          <ParticipantList />
        </div>
      </div>
      {/* <Reconnecting /> */}
      <IdealTimeoutModal />
      <NotificationContainer />
      <ConfirmationDialog />
    </div>
  );
}

export default CallScreen;
